




































# import settings from '@/settings'
import t from '@/utils/tools'
import Menus from '@/components/menus'

export default {
    name: 'users_informations'

    components: { Menus }

    props:
        uid:
            type: String
            required: true
        direct:
            type: Boolean
            default: false

    watch:
        '$route': (route_to, route_from)->
            # console.log "WATCH ROUTE", route_to,
            if route_to.name == 'users_pay_slips'
                @remu_class = 'active'
            else
                @remu_class = ''
            if route_to.name == 'users_informations'
                @define_route()

    data: ()->
        remu_class: ''
        informations_accesses: ['users_self_show', 'user_vouchers_self_show', 'users_jobs_self_show', 'user_salaries_self_show', 'graduates_self_show', 'users_skills_self_show']
        informations_routes: ['users_profile', 'users_vouchers', 'users_jobs', 'users_salaries', 'users_graduates', 'users_skills']

    methods:
        has_access_right: t.has_access_right

        define_route: ()->
            for index, a of @informations_accesses
                if @has_access_right(a)
                    @$router.push({name:@informations_routes[index], params:{uid:@uid}})
                    .catch (err)-> {}
                    break

    mounted: ()->
        # console.log "PROFILE INFORMATION MOUNTED", @uid
        if !@direct
            @define_route()
}

